import { API } from "aws-amplify";

export class CmApi {
  static async publishingHotel(hotelId: number) {
    return await API.get("cm", `/publishingHotel/${hotelId}`, {});
  }
}
